import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../modules/auth/AuthContext';
import { useNavigationData } from '../../modules/NavigationProvider';
import IconSVG from '../IconSVG';

const Header: React.FC = () => {
  const { logout } = useAuth();
  const { t } = useTranslation('navigation');
  const navigate = useNavigate();
  const { headerText } = useNavigationData();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  return (
    <div className="position-relative">
      <div className="text-center px-4">
        <h4 className="text-uppercase">{headerText}</h4>
      </div>
      <Dropdown
        className="position-absolute top-0 end-0"
        align="end"
        drop="down"
      >
        <Dropdown.Toggle
          as={IconSVG}
          name="three-dots"
          color="#555454"
          height={20}
          className="mb-2"
          style={{ cursor: 'pointer' }}
        />

        <Dropdown.Menu className="text-uppercase">
          <Dropdown.Item onClick={() => navigate('/profile')}>
            {t('profile')}
          </Dropdown.Item>
          <Dropdown.Item onClick={() => navigate('/security')}>
            {t('security')}
          </Dropdown.Item>
          <Dropdown.Item onClick={handleLogout}>{t('logout')}</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default Header;
